export const LINKS_SELECTOR = `.docs-item__image-wrapper`;
